<template>
    <section v-if="result" class="package-banner">
        <DefPicture :result="result.pictures"/>
    </section>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'PackageBanner',
        selector: '.package-banner',
        computed: {
            ...mapState({
                result: ({product}) => product.data?.product?.banners?.package,
            })
        },
    }
</script>

<style lang="scss" scoped>
    .package-banner {
        margin: 26px 0 48px;
        @include point-md {
            margin: 42px 0 64px;
        }
        @include point-lg {
            margin: 0 0 64px;
        }
    }

    :deep {
        .def-picture img {
            width: 100%;
        }
    }
</style>